/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type RiskRiskType = (typeof RiskRiskType)[keyof typeof RiskRiskType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RiskRiskType = {
  death_constant: "death_constant",
  death_decreasing_linear: "death_decreasing_linear",
  death_decreasing_annuity: "death_decreasing_annuity",
  accidental_death: "accidental_death",
  disability_3rd_degree_constant: "disability_3rd_degree_constant",
  disability_2nd_degree_constant: "disability_2nd_degree_constant",
  disability_1st_degree_constant: "disability_1st_degree_constant",
  disability_3rd_degree_decreasing_linear: "disability_3rd_degree_decreasing_linear",
  disability_2nd_degree_decreasing_linear: "disability_2nd_degree_decreasing_linear",
  disability_1st_degree_decreasing_linear: "disability_1st_degree_decreasing_linear",
  disability_3rd_degree_decreasing_annuity: "disability_3rd_degree_decreasing_annuity",
  disability_2nd_degree_decreasing_annuity: "disability_2nd_degree_decreasing_annuity",
  disability_1st_degree_decreasing_annuity: "disability_1st_degree_decreasing_annuity",
  critical_illness_decreasing_linear: "critical_illness_decreasing_linear",
  critical_illness_decreasing_annuity: "critical_illness_decreasing_annuity",
  permanent_injury_from_lowest_percent: "permanent_injury_from_lowest_percent",
  permanent_injury_from_10_percent: "permanent_injury_from_10_percent",
  critical_illness_constant: "critical_illness_constant",
  work_incapacity_from_15th_day: "work_incapacity_from_15th_day",
  work_incapacity_from_29th_day: "work_incapacity_from_29th_day",
  work_incapacity_from_57th_day: "work_incapacity_from_57th_day",
  work_incapacity_from_85th_day: "work_incapacity_from_85th_day",
  nursing_allowance_from_15th_day: "nursing_allowance_from_15th_day",
  nursing_allowance_from_29th_day: "nursing_allowance_from_29th_day",
  nursing_allowance_from_57th_day: "nursing_allowance_from_57th_day",
  nursing_allowance_from_85th_day: "nursing_allowance_from_85th_day",
  injury_treatment: "injury_treatment",
  hospitalization_accident: "hospitalization_accident",
  hospitalization_accident_and_illness: "hospitalization_accident_and_illness",
} as const;
